import { getJSON } from './locker'
import _ from 'lodash'

export let getUser = () => {
    let user = getJSON('user');

    if (!_.isObject(user) || _.isEmpty(user)) {
        user = {
            CardType: undefined,
            CellPhone: undefined,
            Email: undefined,
            MemberID: undefined,
            Token: undefined,
            UserName: undefined,
        };
    }

    return user;
};



        